
import { useEffect } from 'react';

interface StructuredDataProps {
  data?: object;
  type?: 'custom' | 'article' | 'breadcrumb' | 'localBusiness' | 'faq' | 'service';
  breadcrumbs?: Array<{ name: string; url: string }>;
}

const StructuredData = ({ data, type = 'custom', breadcrumbs }: StructuredDataProps) => {
  useEffect(() => {
    let structuredData: object;

    if (type === 'breadcrumb' && breadcrumbs) {
      structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };
    } else if (data) {
      structuredData = data;
    } else {
      return;
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data, type, breadcrumbs]);

  return null;
};

export default StructuredData;
